import { Route, Routes } from "react-router-dom";
import BlogDetailPage from "../components/BlogDetailPage";
import BlogListPage from "../components/BlogListPage";

const BlogRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<BlogListPage />} />
      <Route path="/:slug" element={<BlogDetailPage />} />
    </Routes>
  );
};

export default BlogRoutes;
